export default __webpack_public_path__ + "static/media/sl.367f5c71.svg";